import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index'),
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import('@/views/index'),
    },
    {
      path: '/contentPage/:landSn',
      name: 'ContentPage',
      component: () => import('@/views/contentPage'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js